import { useContext } from 'react';

import { PermissionsContext } from '../../../context/permissionsContext';

export function usePermissions() {
  const { permissions, loading } = useContext(PermissionsContext);

  const hasPermission = (perm: string) => permissions.includes(perm);
  const hasAnyPermission = (perms: string[]) => perms.some((p) => permissions.includes(p));
  const hasAllPermissions = (perms: string[]) => perms.every((p) => permissions.includes(p));

  return { hasPermission, hasAnyPermission, hasAllPermissions, permissions, loading };
}
